const getters = {
  isaicalling: state => state.call.isaicalling,
  isseatcalling: state => state.call.isseatcalling,
  visitedViews: state => state.tagsView.visitedViews,
  menus: state => state.tagsView.menu,
  caseinfoPageId: state => state.caseInfoPage.caseinfoPageId,
  curCaseid: state => state.caseInfoPage.curCaseid,
  isRegistered: state => state.webrtc.isRegistered,
  iscalling: state => state.webrtc.iscalling,
  isincall: state => state.webrtc.isincall,
  currentSip: state => state.webrtc.currentSip,
  isAnswer: state => state.webrtc.isAnswer,
  cuiji: state => state.caseInfoPage.cuiji,
  isVirtualNumber: state => state.webrtc.isVirtualNumber,
  virtualNumber: state => state.webrtc.virtualNumber,
}

export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js